export default __webpack_public_path__ + "static/media/clairefontaine7.cd39516d.jpg";